import Interventions from "../interventions"
import Entretiens from "../entretiens"
import Activities from "../activities"

export default () => (
  <div>
    <div className="p-4">
      <div id='types_entretien'>
        <Entretiens.Config />
      </div>
      <div id='entretiens'>
        <Entretiens.Detail />
      </div>
      <div id='interventions'>
        <Interventions.Detail />
      </div>
      <div id='activities'>
        <Activities.Detail />
      </div>
    </div>
  </div>
)